<template>
  <div>
    <tab-bar currentActive="settings" @changeActive="changeTabbar"></tab-bar>
    <div class="container-fluid">
      <div class="row mt-5">
        <div class="col">
          <div class="position-relative w-100">
            <div class="position-absolute" style="z-index: 2000; top: -30px; right: 10px">
              <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                @click="$router.push('/settings').catch(err => { })" style="width: 30px; height: 30px; min-height: 0">
                <icon width="20" height="20" name="times"></icon>
              </div>
            </div>
          </div>
          <h1>PARTAGEZ</h1>
          <h2>EUROS</h2>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <strong>Saisissez un email d'un médecin ou d'un représentant pour lui recommander Euros</strong>
        </div>
      </div>

      <div class="row">
        <div class="col" v-if="!sent">
          <div>
            <label class="mt-2 mb-0" for="">Email</label>
            <m-form-text type="text" v-model="email"></m-form-text>
          </div>
          <div class="mt-3">
            <button class="btn btn-primary" @click="send">Envoyer</button>
          </div>
          <div class="mt-5">
            <strong>Le texte qui sera envoyé est le suivant :</strong>
            <p>
              Bonjour,<br />je suis le docteur {{ this.$store.state.user.co_firstname }} {{
                this.$store.state.user.co_name }}.<br />
              Je vous contact pour vous recommander la société Euros qui propose du matériel pour hanches et
              genoux.<br />
              N'hésitez pas à les contacter au 04 93 58 78 78 ou par email à contacts@euros.fr.<br />
              Cordialement,<br />
              {{ this.$store.state.user.co_firstname }} {{ this.$store.state.user.co_name }}<br />
            </p>
          </div>
        </div>
        <div class="col pt-5" v-else>
          <div class="alert alert-success">
            <p class="mb-0">Votre message a bien été envoyé.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
import { version } from "../../package.json";

export default {
  name: "home-settings",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      version,
      email: "",
      sent: false
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    // this.loadPatients();
    await this.$store.dispatch("setversion");
  },
  watch: {},
  computed: {},
  methods: {
    send() {
      if (!this.email) {
        alert("Veuillez saisir un email valide.");
        return;
      }
      this.sent = true;
      // Here you would typically send the email to your backend or an email service
      // For now, we just log it to the console
      // console.log("Email sent to:", this.email);
    },
    gotoPerso() {
      this.$router.push("/settings/perso").catch(err => {});
    },
    changeTabbar(where) {
      if (where == "patients") {
        this.showPassed = false;
      }
    },
    reloadApp() {
      window.location.reload();
    }

    // async loadPatients() {
    //   let limit = 30;
    //   let sort = this.sortFields.reduce((accumulator, field) => {
    //     if (accumulator) accumulator += ", ";
    //     accumulator += field + " " + this.sortOrder;
    //     return accumulator;
    //   }, "");
    //   if (this.archive) limit = 100000;
    //   let params = {
    //     pa_archive: this.archive,
    //     // text: this.filterText,
    //     sort: sort,
    //     limit: limit,
    //     pa_type: "hanche"
    //   };
    //   let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients", { params });
    //   this.patients_today = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isSame(this.$dayjs(), "day");
    //   });
    //   this.patients_tomorrow = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isSame(this.$dayjs().add(1, "day"), "day");
    //   });
    //   this.patients_future = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isAfter(this.$dayjs().add(1, "day"), "day");
    //   });
    //   this.patients_past_week = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isBetween(this.$dayjs().add(-7, "day"), this.$dayjs(), "day");
    //   });
    //   this.patients_past_month = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isBetween(this.$dayjs().add(-30, "day"), this.$dayjs().add(-7, "day"), "day");
    //   });
    //   this.patients_past_other = response.data.data.filter(p => {
    //     return this.$dayjs(p.pa_dateoperation).isBefore(this.$dayjs().add(-30, "day"), "day");
    //   });
    //   // console.log("🚀 ~ loadPatients ~ this.patients:", this.patients);
    //   // this.patients = this.patients.filter(p => {
    //   //   if (!this.filterText) return true;
    //   //   if (p.pa_name.toLocaleLowerCase("fr").indexOf(this.filterText.toLocaleLowerCase("fr")) >= 0) return true;
    //   //   return false;
    //   // });
    //   // if (response.data.meta) this.patients_total = response.data.meta.total;
    //   // else this.patients_total = this.patients.length;
    // },
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.cguwin {
  position: fixed;
  background-color: white;
  border: 1px solid black;
  top: 5%;
  height: 90%;
  width: 90%;
  left: 5%;
  z-index: 10001;
  padding: 20px;

  // overflow: auto;
  .btn-jaccepte {
    position: absolute;
    bottom: 5px;
  }
}

.cguwin-content {
  overflow: auto;
}

@media (min-width: 576px) {
  .helpwin {}
}

@media (min-width: 768px) {
  .helpwin {}
}

.h-100vh {
  height: 100vh;
}

.bg-blue2 {
  background-color: rgb(161, 173, 194);
}

.topwhite {
  background-color: white;
  border-radius: 20px;
  padding: 20px;
}

.buttonsettings {
  width: 100%;
  text-align: left;
  background-color: rgb(237, 236, 236);
  border-radius: 10px;
  color: rgb(12, 40, 56);
  padding: 20px;
}

.btn-icon {
  background-color: #c6091f;
  color: white;
}
</style>
